import { Link } from "react-router-dom";
import Back from "./../../../../assets/icons/back.svg";
import { useEffect, useState } from "react";
import { Pagination, message, Tag } from "antd";
import Table from "../../../../components/common/table";
import React from "react";
import Delete from "../../../../assets/icons/delete.svg";
import View from "../../../../assets/icons/view.svg";
import Trash from "../../../../assets/icons/trash.svg";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrders } from "../../../../store/slices/orderSlice";
import OrderDetailsCard from "./orderDetailsCard";
import ServiceCard from "./serviceCard";
import ReviewsCard from "../../../../components/common/reviewsCard";
import { fetchReviewList } from "../../../../store/slices/reviewSlice";
import moment from "moment";
import DeleteMemberModal from "../../../../components/common/modalMember";
import { deleteReview } from "../../../../api/customerReview";
import { resetText } from "../../../../store/slices/textSlice";
import { deleteOrder, refundPaymentOrder } from "../../../../api/order";

const Orders = () => {
  const columns = [
    {
      title: "Order #",
      dataIndex: "orderNumber",
      key: "orderNumber",
    },
    {
      title: "Customer",
      key: "customerName",
      dataIndex: "customerName",
    },
    {
      title: "Vendor",
      key: "vendorName",
      dataIndex: "vendorName",
    },
    {
      title: "Amount ($)",
      dataIndex: "price",
      key: "price",
      render: (text, record) => {
        const bannerText = record?.items?.cartDiscountRuleBannerText;
        return (
          <div className="flex flex-col gap-0.5">
            <span>${text}</span>
            {bannerText ? (
              <Tag color="green">{bannerText}</Tag>
            ) : null}
          </div>
        );
      },
    },
    {
      title: "Service(s)",
      key: "noOfItems",
      render: (text, record) =>
        `${record?.items.serviceDetails[0]?.serviceName}`,
    },
    {
      title: "Promo Code",
      key: "promoCode",
      // dataIndex: "promoCodeId",
      render: (text, record) => {
        return record?.promoCode?.length ? (
          <Tag color="volcano">
            {record?.promoCode[0]?.promoCode} (
            {record?.promoCode[0]?.isPercent
              ? `${record?.promoCode[0]?.discountAmount}%`
              : `$${record?.promoCode[0]?.discountAmount}`}
            )
          </Tag>
        ) : (
          <Tag>Not Applied</Tag>
        );
      },
    },
    {
      title: "Created At",
      key: "createdAt",
      render: (text, record) =>
        `${moment(record.createdAt).format("MM/DD/YYYY hh:mm A")}`,
    },
    {
      title: "Status",
      key: "orderStatus",
      dataIndex: "orderStatus",
      render: (status) => OrderStatusTag(status),
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <div className="flex space-x-2">
          <Link to={`/main/order-details/${record?._id}`}>
            <div className="w-4 m-auto grid justify-center h-4 pt-1 rounded-full bg-lightLavender cursor-pointer">
              <img src={View} alt="View" />
            </div>
          </Link>
          <div
            className="w-4 m-auto grid justify-center h-4 pt-1 rounded-full bg-lightCrimson cursor-pointer"
            onClick={() => onShowDeleteOrderModalHandler(record)}
          >
            <img src={Trash} alt="Delete" />
          </div>
        </div>
      ),
    },
  ];

  const OrderStatusTag = (status) => {
    return (
      <>
        {status === "COMPLETED" ? (
          <Tag color="success">Completed</Tag>
        ) : (
          <Tag color="warning">Not Redeemed</Tag>
        )}
      </>
    );
  };

  const itemRender = (page, type, originalElement) => {
    if (type === "page") {
      return (
        <div
          className={`rounded ${
            currentPage === page
              ? "bg-primaryPurple text-white"
              : "bg-white text-black"
          }`}
          style={{ cursor: "pointer" }}
        >
          {page}
        </div>
      );
    }
    return originalElement;
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPagesize] = useState(10);
  const dispatch = useDispatch();
  const [showDetails, setShowDetails] = useState();
  const [reviewCurrentPage, setReviewCurrentPage] = useState(1);
  const [reviewPageSize, setReviewPagesize] = useState(4);
  const [showReview, setShowReview] = useState(false);
  const [selectedService, setSelectedService] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteOrderModalOpen, setIsDeleteOrderModalOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState();
  const [isRefundModalOpen, setIsRefundModalOpen] = useState(false);
  const [refundPayload, setRefundPayload] = useState();
  const orderLoading = useSelector((state) => state?.order?.isLoading);
  const orders = useSelector((state) => state?.order?.res);
  const [render, setRender] = useState(false);
  const [reviewId, setReviewId] = useState();
  const reviews = useSelector((state) => state?.review?.res);
  const text = useSelector((state) => state?.text?.value);
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleReviewPageChange = (page) => {
    setReviewCurrentPage(page);
  };
  const onShowDeleteOrderModalHandler = (record) => {
    setIsDeleteOrderModalOpen(true);
    setSelectedOrder(record);
  };
  const handleSizeChange = (current, size) => {
    setPagesize(size);
  };
  const handleReviewSizeChange = (current, size) => {
    setReviewPagesize(size);
  };
  const YesClickHandler = async () => {
    setIsModalOpen(false);
    const res = await deleteReview(reviewId);
    if (res) {
      setRender(!render);
      message.success("Review Deleted!");
    }
  };

  const onDeleteOrderHandler = async () => {
    setIsDeleteOrderModalOpen(false);
    const res = await deleteOrder(selectedOrder?._id);
    if (res) {
      setRender(!render);
      message.success("Order Deleted!");
    }
  };

  const hideModal = () => {
    setIsModalOpen(false);
    setIsRefundModalOpen(false);
  };

  const showRefundModal = (e) => {
    setRefundPayload(e);
    setIsRefundModalOpen(e);
  };

  useEffect(() => {
    const payload = {
      pageNumber: currentPage,
      itemPerPage: pageSize,
      text: text || null,
      filterBy: selectedFilter
    };
    dispatch(fetchOrders(payload));
  }, [currentPage, pageSize, text, render]);

  useEffect(() => {
    dispatch(resetText());
  }, []);

  useEffect(() => {
    if (selectedService) {
      const payload = {
        currentPage: reviewCurrentPage,
        itemPerPage: reviewPageSize,
        serviceId: selectedService?._id,
      };
      dispatch(fetchReviewList(payload));
    }
  }, [showDetails, showReview, selectedService, render, reviewCurrentPage]);

  const yesRefundClickHandler = async () => {
    const payload = {
      orderId: refundPayload?.orderId,
      paymentId: refundPayload?.paymentId,
    };
    setIsRefundModalOpen(false);
    const res = await refundPaymentOrder(payload);
    if (res) {
      setRender(!render);
      setShowDetails(false);
      message.success("Payment Refunded Successfully!");
    }
  };

  const handleServiceClick = (item) => {
    setShowReview(true);
    setSelectedService(item?.serviceDetails);
  };
  const showModal = (id) => {
    setReviewId(id);
    setIsModalOpen(true);
  };

  const filterOptions = [
    { label: "No Filter", value: "" },
    { label: "Vendor", value: "vendor" },
    { label: "Customer", value: "customer" },
    { label: "Order No.", value: "orderNo" },
    { label: "Customer Email", value: "customerEmail" },
  ];

  const [selectedFilter, setSelectedFilter] = useState("");

  return (
    <>
      <div>
        <div className="flex items-center ml-2 mt-2 ">
          <Link
            to={""}
            className="flex items-center"
            onClick={() => {
              setShowReview(false);
              setShowDetails(false);
            }}
          >
            {showDetails && <img src={Back} alt="back" />}
            <span className="text-lg font-medium text-black ml-1">Orders</span>
          </Link>
        </div>

        {!showDetails ? (
          <div>
            <div className="ml-3">
              <h4> Filter By:</h4>
              {filterOptions.map((option) => (
                <label key={option.value} style={{ marginRight: "1rem" }}>
                  <input
                    type="radio"
                    name="filter"
                    value={option.value}
                    checked={selectedFilter === option.value}
                    onChange={(e) => {setSelectedFilter(e.target.value);}}
                  />
                  {option.label}
                </label>
              ))}
            </div>
            <div>
              <div>
                <div className="min-h-screen flex items-start justify-start pt-0">
                  <Table
                    columns={columns}
                    data={orders?.items}
                    loading={orderLoading}
                  />
                </div>
              </div>
            </div>
            <div className="flex justify-center items-center pagination-container mb-2">
              <Pagination
                current={currentPage}
                total={orders?.totalItems}
                pageSize={pageSize}
                onShowSizeChange={handleSizeChange}
                pageSizeOptions={[10, 20, 30, 40]}
                onChange={(e) => {
                  handlePageChange(e);
                }}
                itemRender={itemRender}
                responsive={true}
                className="custom-pagination"
              />
            </div>
          </div>
        ) : (
          <div className="mt-2 ">
            <OrderDetailsCard
              data={showDetails}
              showRefundModal={showRefundModal}
            />
            <p className="text-lg ml-2">Services</p>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-3 xl:grid-cols-4 ">
              {showDetails?.items?.map((item, i) => (
                <div
                  className="flex justify-start "
                  onClick={() => handleServiceClick(item)}
                  key={i}
                >
                  <ServiceCard
                    services={item}
                    business={showDetails?.businessId}
                  />
                </div>
              ))}
            </div>
            {showReview && reviews?.totalItems > 0 ? (
              <div>
                <p className="text-lg ml-2 mb-2">Reviews</p>
                {reviews?.items?.map((item, i) => (
                  <React.Fragment key={i}>
                    <div className="mb-2">
                      <ReviewsCard
                        rating={item?.rating}
                        customer={
                          item?.customerUserId?.firstName +
                          " " +
                          item?.customerUserId?.lastName
                        }
                        customerImg={item?.customerUserId?.profileImage}
                        date={moment(item?.createdAt).format("MM/DD/YYYY")}
                        review={item?.comments[0].commentText}
                        msg={Delete}
                        openModal={(id) => showModal(id)}
                        id={item?._id}
                      />
                    </div>
                  </React.Fragment>
                ))}
                <div className="flex justify-center items-center pagination-container mb-2">
                  <Pagination
                    current={reviewCurrentPage}
                    total={reviews?.totalItems}
                    pageSize={reviewPageSize}
                    pageSizeOptions={[10, 20, 30, 40]}
                    onShowSizeChange={handleReviewSizeChange}
                    onChange={(e) => {
                      handleReviewPageChange(e);
                    }}
                  />
                </div>
              </div>
            ) : (
              <div
                className={`flex justify-center ${
                  showReview ? "" : "hidden"
                } text-lg opacity-60 mt-4`}
              >
                No Service Reviews
              </div>
            )}
          </div>
        )}
      </div>
      {isDeleteOrderModalOpen && (
        <DeleteMemberModal
          title="Delete Order"
          text="Are you sure you want to delete this order?"
          onCancel={() => setIsDeleteOrderModalOpen(false)}
          onOk={onDeleteOrderHandler}
        />
      )}
      {isModalOpen && (
        <DeleteMemberModal
          title="Delete Review"
          text="Are you sure you want to delete this review?"
          onCancel={hideModal}
          onOk={YesClickHandler}
        />
      )}
      {isRefundModalOpen && (
        <DeleteMemberModal
          title="Refund Payment"
          text="Are you sure you want to refund this payment?"
          onCancel={hideModal}
          onOk={yesRefundClickHandler}
        />
      )}
    </>
  );
};
export default Orders;
